import React from 'react';
import { cn } from '@/lib/utils';
import { LucideIcon } from 'lucide-react';

type IconSize = 'sm' | 'md' | 'lg';

interface IconProps extends React.HTMLAttributes<HTMLSpanElement> {
  icon: LucideIcon;
  size?: IconSize;
  color?: string;
}

const sizeMap: Record<IconSize, number> = { sm: 14, md: 18, lg: 24 };

const Icon: React.FC<IconProps> = ({ icon: LIcon, size = 'md', color, className, ...props }) => (
  <span className={cn('inline-flex items-center justify-center flex-shrink-0', className)} {...props}>
    <LIcon size={sizeMap[size]} color={color} strokeWidth={2} />
  </span>
);

export { Icon };
export type { IconProps, IconSize };
